export const Youtube = () => (
  <svg
    width="45"
    height="32"
    viewBox="0 0 45 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43.0454 5.69136C42.8004 4.78269 42.3207 3.9542 41.6541 3.28882C40.9876 2.62343 40.1577 2.1445 39.2475 1.89994C36.7599 0.940553 12.6607 0.470516 5.66896 1.92677C4.7586 2.17142 3.9286 2.65052 3.26205 3.3161C2.59551 3.98169 2.11582 4.8104 1.87101 5.71926C0.74764 10.6375 0.662715 21.2702 1.89896 26.2989C2.14393 27.2076 2.6237 28.0361 3.29023 28.7015C3.95676 29.3668 4.78668 29.8458 5.69691 30.0903C10.6236 31.2225 34.0456 31.3813 39.2754 30.0903C40.1856 29.8458 41.0156 29.3668 41.6821 28.7015C42.3486 28.0361 42.8284 27.2076 43.0734 26.2989C44.2709 20.9407 44.3558 10.9669 43.0454 5.69136V5.69136Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.5596 15.9946L18.3291 9.56543V22.4238L29.5596 15.9946Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
